import type { IconData } from '@stacksjs/iconify-core'

export const unlock: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7 9h10a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3\"/><path fill=\"currentColor\" d=\"M9 7a3.002 3.002 0 0 1 5.116-2.13c.378.383.65.858.786 1.379l.002.007a1 1 0 0 0 1.934-.505a5.1 5.1 0 0 0-1.306-2.293A5.002 5.002 0 0 0 7 7v2h2z\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default unlock
